// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"video-camera-minus"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 5L0.999999 19L16 19L16 5L1 5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M23 6L16 10.2L16 14L23 18L23 6Z"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M23 6L16 10.2V14L23 18V6Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M1 5L1 19H16V5L1 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5.5 12L11.5 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const VideoCameraMinusIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-minus',
    ref,
    icon: element,
  },
));

VideoCameraMinusIcon.displayName = 'VideoCameraMinusIcon';

export default VideoCameraMinusIcon;
